var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparisonTypeFacilityFacilityPlatform(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H5C3.34315 10 2 11.3431 2 13V27C2 28.6569 3.34315 30 5 30H17C18.6569 30 20 28.6569 20 27V13C20 11.3431 18.6569 10 17 10Z",
    fill: "#8080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10H35C33.3431 10 32 11.3431 32 13V27C32 28.6569 33.3431 30 35 30H47C48.6569 30 50 28.6569 50 27V13C50 11.3431 48.6569 10 47 10Z",
    fill: "#8080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4H20C18.8954 4 18 4.89543 18 6V8C18 9.10457 18.8954 10 20 10H32C33.1046 10 34 9.10457 34 8V6C34 4.89543 33.1046 4 32 4Z",
    fill: "#FF6833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTypeFacilityFacilityPlatform);
export default __webpack_public_path__ + "static/media/comparison-type-facility-facility-platform.2c7ebd8509951c4e5d8c1805c87f41c1.svg";
export { ForwardRef as ReactComponent };